// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

export const suspendAccount = createAsyncThunk(
	"globalUser/suspendAccount",
	createApiCall(async ({ password }, client) => {
		const response = await client.put(`/setting/suspend/web`, {
			password,
		});
		return response.data;
	})
);

// ############################################################
